import React from "react";
import { Row } from "antd";

export default class Education extends React.Component {
    render() {
        return(
            <div style={{marginTop:72}}>
                <Row type="flex" justify="center">
                    <p style={{fontSize:24,color:'#858585'}}>米弘教育行业方案</p>
                </Row>
            </div>
        )
    }
}